export default "__VITE_ASSET__BNt2Yzm5__"